

$(".navbar-toggler").click(function () {

    $(".navbar-toggler").toggleClass("showtoggle");

});



$(".closed").click(function () {

    $(".navbar-collapse").removeClass("show");

});


$(".jobsbtn span").click(function () {
    $(".topjobbox").slideToggle("slow");
});


$(".searh_bx a").click(function () {
    $(".topjobbox").slideToggle("slow");
});


$(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $(".header_sec").addClass("fixed");

    } else {
        $(".header_sec").removeClass("fixed");
    }
    if (scroll >= 250) {
        $(".backTop").addClass("actv");

    } else {
        $(".backTop").removeClass("actv");
    }
});


$(document).ready(function () {
    var owl = $('.job-caro.owl-carousel');
    owl.owlCarousel({
        dots: false,
        // navText : ["<i class='fa-solid fa-angle-left'></i>","<i class='fa-solid fa-angle-right'></i>"],
        autoplay: false,
        nav: false,
        margin: 20,
        dotsEach: false,
        stagePadding: 0,
        loop: true,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                stagePadding: 40,
                autoplay: true,
                margin: 10,
            },
            400: {
                items: 1,
                stagePadding: 40,
                autoplay: true,
                margin: 10,
            },
            500: {
                items: 1,
                stagePadding: 80,
                autoplay: true,
            },
            576: {
                items: 1,
                stagePadding: 120,
                autoplay: true,
            },
            768: {
                items: 2
            },
            1300: {
                items: 3
            },
            1400: {
                items: 3
            }
        }
    });
});


$(document).ready(function () {
    var owl = $('.news-caro.owl-carousel');
    owl.owlCarousel({
        dots: false,
        // navText : ["<i class='fa-solid fa-angle-left'></i>","<i class='fa-solid fa-angle-right'></i>"],
        autoplay: false,
        nav: false,
        margin: 20,
        dotsEach: false,
        stagePadding: 0,
        loop: true,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                stagePadding: 40,
                autoplay: true,
                margin: 10,
            },
            400: {
                items: 1,
                stagePadding: 40,
                autoplay: true,
                margin: 10,
            },
            500: {
                items: 1,
                stagePadding: 80,
                autoplay: true,
            },
            576: {
                items: 1,
                stagePadding: 120,
                autoplay: true,
            },
            768: {
                items: 2
            },
            1300: {
                items: 3
            },
            1400: {
                items: 3
            }
        }
    });
});

$(document).ready(function () {
    var owl = $('.meet-caro.owl-carousel');
    owl.owlCarousel({
        dots: false,
        // navText : ["<i class='fa-solid fa-angle-left'></i>","<i class='fa-solid fa-angle-right'></i>"],
        autoplay: true,
        autoplayHoverPause: true,
        nav: false,
        margin: 20,
        dotsEach: false,
        stagePadding: 0,
        loop: true,
        responsive: {
            0: {
                items: 1,
                stagePadding: 40,
                autoplay: true,
                margin: 10,
            },
            400: {
                items: 1,
                stagePadding: 40,
                autoplay: true,
                margin: 10,
            },
            500: {
                items: 1,
                stagePadding: 80,
                autoplay: true,
            },
            576: {
                items: 1,
                stagePadding: 120,
                autoplay: true,
            },
            768: {
                items: 1,
                stagePadding: 120,
            },
            1300: {
                items: 1,
                stagePadding: 120,
            },
            1399: {
                stagePadding: 380,
                items: 1
            },
            1400: {
                stagePadding: 230,
                items: 1
            },
            1500: {
                stagePadding: 300,
                items: 1
            },
            1800: {
                stagePadding: 480,
                items: 1
            },
            2200: {
                stagePadding: 180,
                items: 2
            }
        }
    });
});

$(document).ready(function () {
    var owl = $('.partner-banner.owl-carousel');
    owl.owlCarousel({
        margin: 20,
        dots: false,
        autoplay: true,
        autoplayHoverPause: true,
        nav: false,
        dotsEach: false,
        loop: true,
        navText: [
            '<i class="fa-solid fa-angle-left"></i>', // Icon for the previous button
            '<i class="fa-solid fa-angle-right"></i>', // Icon for the next button
        ],
        responsive: {
            0: {
                items: 1
            },
            481: {
                items: 2
            },
            576: {
                items: 3
            },
            768: {
                items: 3
            },
            992: {
                items: 4
            },
            1200: {
                items: 5
            }
        }
    });
});


$(document).ready(function () {
    var owl = $('.middle-banner.owl-carousel');
    owl.owlCarousel({
        margin: 20,
        dots: false,
        autoplay: true,
        autoplayHoverPause: true,
        nav: true,
        dotsEach: false,
        loop: true,
        navText: [
            '<i class="fa-solid fa-arrow-left"></i>', // Icon for the previous button
            '<i class="fa-solid fa-arrow-right"></i>', // Icon for the next button
        ],
        responsive: {
            0: {
                items: 1
            },
            1200: {
                items: 1
            }
        }
    });
});


document.addEventListener("DOMContentLoaded", function () {

    const accordion = document.getElementById("accordionExample");

    accordion.addEventListener("show.bs.collapse", function (e) {

        const currentItem = e.target.closest(".accordion-item");

        // Remove class from all siblings
        const allItems = accordion.querySelectorAll(".accordion-item");
        allItems.forEach(item => {
            item.classList.remove("accordion-active");
        });

        // Add class to current open item
        currentItem.classList.add("accordion-active");
    });

    accordion.addEventListener("hide.bs.collapse", function (e) {
        const currentItem = e.target.closest(".accordion-item");
        currentItem.classList.remove("accordion-active");
    });

});
